// @flow

import gql from 'graphql-tag';

import { useMutation } from '@apollo/react-hooks';

import { type SurveyType } from './types';

type Input = {
  accountId: ?number,
};

type Output = {
  error: ?string,
  hasSaved: boolean,
  isLoading: boolean,
  onSaveSurvey: SurveyType => void,
};

const saveTrialOnboardingSurveyMutation = gql`
  mutation saveTrialOnboardingSurvey(
    $accountId: Int!
    $input: TrialOnboardingSurvey!
  ) {
    trialOnboardingSurvey(accountId: $accountId, input: $input) {
      id
    }
  }
`;

function useTrialOnboardingSurvey({ accountId }: Input): Output {
  const [saveSurvey, results] = useMutation(saveTrialOnboardingSurveyMutation);

  function onSaveSurvey(survey) {
    saveSurvey({
      variables: {
        accountId,
        input: {
          ...survey,
          type: 'Company',
        },
      },
    });
  }

  return {
    error: results.error,
    hasSaved: results.called,
    isLoading: results.loading,
    onSaveSurvey,
  };
}

export default useTrialOnboardingSurvey;
